import { Form, Input, Row, Col, Switch, InputNumber, ColorPicker, Select } from 'antd';
import { useRef, useEffect, useState } from 'react';
import AntDraggableModal from '../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../system/WebEditUniversalNewEx';
import fetchApi from '../../utils/api/fetchApi';
import getList from '../../utilsTsx/universal/getList';

const EditComponent = (props: any) => {
    const [form] = Form.useForm();
    const { data } = props;
    const ref = useRef<any>(undefined);

    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [InitData, setInitData] = useState<any>();
    const [faPiaoTypeData, setFaPiaoTypeData] = useState<any>();

    useEffect(() => {
        let serviceUrl;
        if (ref.current) {
            serviceUrl = ref.current.defaultService;
            setDefaultService(serviceUrl);
            setInitData(() => ref.current.initData);
        }
        fetchApi.GET(serviceUrl,
            {
                apiId: 'generalData',
                apiVariable: 'faPiaoType',
                apiExtend: 'showLists'
            }).then(res => {
                if (res.success === true) {
                    const { faPiaoType } = res.data;
                    setFaPiaoTypeData(faPiaoType);
                }
            })
    }, []);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'faPiaoType',
        serviceId: 'business'
    };

    const onSelectHandle = (e: any) => {
        form.setFieldValue('typeName', e.item.name);
    }

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '发票类型'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Row gutter={[8, 0]}>
                        <Col span={12}>
                            <Form.Item
                                label="id"
                                name="id"
                                rules={[{ required: true, message: 'id!' }]}>
                                <Select
                                    disabled={data.type === 'NEW' ? false : true}
                                    showSearch
                                    placeholder="id"
                                    optionFilterProp="children"
                                    onSelect={(_key, e) => onSelectHandle(e)}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.general(faPiaoTypeData, {
                                        setItemNameFun: (item: any) => {
                                            const { id, name } = item;
                                            return {
                                                id,
                                                name: `${id}【${name}】`
                                            }
                                        }
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="名称"
                                name="typeName">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="默认"
                                name="isDefault"
                                valuePropName="checked"
                                initialValue={false}>
                                < Switch checked={false}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default EditComponent;